import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container } from '@che-ins-ui/container';
import { useTitle } from 'react-use';
import { InsuranceStep } from '@/models/steps';
import { currentStepSelector } from '@/models/steps/selectors';
import { reachAnalyticsGoal, YANDEX_GOALS } from '@/libs/analytics';
import { useStyles } from './styles';
import { FormsTab } from './components/Forms/FormsTab';
import { DetailsTab } from './components/Details/DetailsTab';
import { FlightsTab } from './components/Flights/FlightsTab';
import { AsideNavigation } from './components/AsideNavigation/AsideNavigation';
const components = {
    [InsuranceStep.flights]: FlightsTab,
    [InsuranceStep.forms]: FormsTab,
    [InsuranceStep.details]: DetailsTab,
};
const stepGoals = {
    [InsuranceStep.flights]: YANDEX_GOALS.flightsPage,
    [InsuranceStep.forms]: YANDEX_GOALS.passengersPage,
    [InsuranceStep.details]: YANDEX_GOALS.detailsPage,
};
export const Insurance = () => {
    const currentStep = useSelector(currentStepSelector);
    const classes = useStyles();
    useTitle('Заполнение данных страхового полиса');
    useEffect(() => {
        reachAnalyticsGoal(stepGoals[currentStep]);
    }, [currentStep]);
    const Component = components[currentStep];
    return (_jsx(_Fragment, { children: _jsx(Container, { baseAppearance: "page", children: _jsxs("div", { className: classes.root, children: [_jsx(AsideNavigation, {}), _jsx("div", { className: classes.splitter }), _jsx("div", { className: classes.content, children: _jsx(Component, {}) })] }) }) }));
};
